import { setAuthTokenInCookie } from '@ms/yammer-data/dist/api/imageRenderingCookie';
import { getAdalResourceForYammer } from '@ms/yammer-data/dist/domains/session/selectors';
import type { YammerState } from '@ms/yammer-data/dist/state/types';
import { reportError } from '@ms/yammer-telemetry';
import { acquireToken } from '@ms/yammer-web-authenticators';

import { writeCookies } from '../../cookies';

import { reportErrorWithCode } from './bootstrapTelemetry';

type RepairToken = (state: YammerState) => Promise<void>;
export const repairToken: RepairToken = async (state: YammerState) => {
  try {
    const yammerResource = getAdalResourceForYammer(state);
    const token = await acquireToken({ scopes: [yammerResource] });

    const response = await setAuthTokenInCookie(state, token);
    if (!response.ok) {
      throw new Error(`Failed to set image rendering cookie. Received status: ${response.status}`);
    }

    try {
      writeCookies(token);
    } catch (error) {
      reportErrorWithCode(error, 'WriteHostingCookiesFailed');
    }
  } catch (error) {
    reportError({
      error,
      eventProperties: { errorCode: 'RepairTokenFailed' },
    });
  }
};
